
import {Component, Vue} from 'vue-property-decorator'

import {VBottomSheet} from 'vuetify/lib'

@Component({
  name: 'BottomSheet',
  extends: VBottomSheet as any,
})
export default class BottomSheet extends Vue {
}
